import { render, staticRenderFns } from "./OrganizationMerge.vue?vue&type=template&id=093907b8"
import script from "./OrganizationMerge.vue?vue&type=script&lang=ts"
export * from "./OrganizationMerge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports